export default {
  forgot_password_confirm: {
    title: 'Passwort zurücksetzen',
    required_code: 'Code ist erforderlich',
    required_password: 'Passwort ist erforderlich',
    max_length_16: 'Das Passwort muss aus 8-16 Zeichen bestehen',
    // no_blank: "",
    no_password_match: 'Passwort stimmt nicht überein',
    reset_password: 'Passwort zurücksetzen',
    caution: 'Bitte schließen Sie dieses Fenster nicht',
    double_check_text: '@:login.double_check_text',
    password_reset_text: 'Es wurde eine E-Mail an die angegebene Adresse gesendet. Bitte geben Sie den Verifizierungscode ein, der an Ihre E-Mail gesendet wurde.',
    verification_code: 'Verifizierungscode',
    mail_send_code: 'Code in E-Mail gesendet',
    password: 'Passwort',
    new_password: 'Neues Passwort',
    password_display: 'Passwort anzeigen',
    password_no_display: 'Passwort verbergen',
    password_check: 'Neues Passwort (Bestätigen)',
    submit: 'Bestätigen',
  },
}
